import {Component, h} from 'preact'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'
import UserAvatar from '../User/UserAvatar'
import LazyLoader from '../lazy-loading/LazyLoader'

interface Member {
  id: number,
  url: string,
  avatar: string
}

export interface Group {
  id: string,
  title: string,
  url: string,
  totalMembers: number,
  totalTopics: number,
  recentMembers: Array<Member>,
  thumbnail: string,
  isUserMember?: boolean
}

interface GroupItemProps extends Group {
  isUserMember?: boolean,
  isEvenCount: boolean
}

export class GroupItem extends Component<GroupItemProps> {
  render (group: GroupItemProps) {
    return <a class={`group-overview-item card-widget-wrapper ${group.isEvenCount ? 'group-overview-item--even' : ''}`} href={group.url}>
      <LazyLoader type='background' src={group.thumbnail} classNames='group-overview-item__top'>
        <div className='group-overview-item__top-content'>
          {
            group.recentMembers.reverse().map(member => {
              if (member.id.toString() === window.inSidedData.user.userid) {
                return null
              }

              return <div key={member.id} className='group-overview-item__member'>
                <span className='group-overview-item__member-link'>
                  <UserAvatar
                    user={member}
                    extraClass='avatar avatar--S'
                    showRank
                  />
                </span>
              </div>
            })
          }

          {
            group.isUserMember
              ? <div key='me' className='group-overview-item__member'>
                <span className='group-overview-item__member-link'>
                  <Icon icon='checkmark' height={30} width={30}/>
                </span>
              </div>
              : null
          }
        </div>
      </LazyLoader>
      <div class='group-overview-item__bottom'>
        <h4 class='card-widget-title'>{group.title}</h4>
        <div class='group-overview-item__meta group-overview-item__meta--members-total text--meta'>
          <Icon width={20} height={20} icon='people' /> <span class='group-overview-item__meta-text'>{group.totalMembers} <Phrase p='Members'/></span>
        </div>
        <div class='group-overview-item__meta group-overview-item__meta--topics-total text--meta'>
          <Icon width={20} height={20} icon='conversation' /> <span class='group-overview-item__meta-text'>{group.totalTopics} <Phrase p='Topic|Topics' count={{ n: group.totalTopics.toString() }} /></span>
        </div>
      </div>
    </a>
  }
}

interface Props {
  myGroups: Array<Group>,
  otherGroups: Array<Group>,
}

class GroupsOverview extends Component<Props> {
  render({myGroups, otherGroups}: Props) {
    return <div class='group-overview-wrapper'>
      <div class='sitewidth text-center'>
        <h1 class='group-overview-wrapper-title'><Phrase p='groups' /></h1>
      </div>

      {myGroups.length ? <div class='groups--mine'>
        <h4 class='group-overview-title'><Phrase p='groups.my.groups' /></h4>

        <div class='group-overview'>
          {
            myGroups.map(group => <GroupItem isEvenCount={myGroups.length === 2 || myGroups.length === 4} isUserMember {...group} />)
          }
        </div>
      </div> : null}
      {
        otherGroups.length ? (
          <div className='groups--other'>
            {myGroups.length ? <h4 className='group-overview-title'><Phrase p='groups.find.new.group'/></h4> : null}

            <div className='group-overview'>
              {
                otherGroups.map(group => <GroupItem
                  isEvenCount={otherGroups.length === 2 || otherGroups.length === 4} {...group} />)
              }
            </div>
          </div>
        ) : null
      }
    </div>
  }
}

export default GroupsOverview
